import { BarController } from 'chart.js';

class CustomBarHorizontalController extends BarController {

    draw() {
        let chart = this.chart;
        let xScale = this.chart.scales['x'];
        let yScale = this.chart.scales['y'];
        const goalColor = this.chart.config._config.options.swapped ? "rgba(98, 63, 234, 1)" : "rgb(102, 255, 204)";
        const isMobile = this.chart.config._config.options.isMobile;

        // @NOTE: Draw the y axis values on the far right
        if (yScale !== undefined) {
            const dailyGoal = chart.config._config.data.dailyGoal;

            yScale.options.grid.display = false;

            let textTop = yScale.top - 15;

            if (isMobile) {
                textTop += 5;
            }

            if (isMobile) {
                this.chart.ctx.font = "10px 'Grotesk', 'arial'";
                this.chart.ctx.textAlign  = "left";
                this.chart.ctx.fillStyle = "#FFFFFF";
                this.chart.ctx.fillText(this.chart.config._config.options.title, xScale.left - 20, textTop);
            }

            yScale.ticks.forEach((label, index) => {
                let xValue = chart.config._config.data.datasets[0].data[index];
                const formatter = this.chart.config._config.options.valueFormatter;

                if (xValue) {
                    const yPos = yScale.getPixelForTick(index);

                    this.chart.ctx.font = "normal normal 600 12px Grotesk";
                    this.chart.ctx.textAlign  = "right";
                    this.chart.ctx.fillStyle = (xValue >= dailyGoal) ? goalColor : "#FFFFFF";

                    if (formatter) {
                        xValue = formatter(xValue);
                    }

                    this.chart.ctx.fillText(xValue, xScale.right, yPos);
                }
            });

            // @NOTE: Alternative way to draw the vertical lines
            /*
            xScale.ticks.forEach((label, index) => {
                const tickPos = xScale.getPixelForTick(index);

                chartContext.save();
                chartContext.beginPath();

                chartContext.moveTo(tickPos, yScale.top);
                chartContext.lineTo(tickPos, yScale.bottom);
                chartContext.strokeStyle = gridLineColor;

                chartContext.lineWidth = 1;
                chartContext.stroke();
                chartContext.restore();
            });
            */
        }

        // @NOTE: Draw the average and goal vertical lines and text header for them
        const dailyAverage = chart.config._config.data.dailyAverage;

        if (dailyAverage && xScale && yScale) {
            const xPos = xScale.getPixelForValue(dailyAverage);

            this.chart.ctx.beginPath();
            this.chart.ctx.moveTo(xPos, Math.round(yScale.top));
            this.chart.ctx.strokeStyle = 'grey'; // @NOTE: Get exact color, do pass in and don't hard code here
            this.chart.ctx.setLineDash([5, 5]);
            this.chart.ctx.lineWidth = 1;
            this.chart.ctx.lineTo(xPos, Math.round(yScale.bottom));
            this.chart.ctx.stroke();

            this.chart.ctx.font = "bold 8px 'Grotesk', 'arial'";
            this.chart.ctx.textAlign  = "center";
            this.chart.ctx.fillStyle = "grey";
            this.chart.ctx.fillText("AVG", xPos, yScale.top - 10);

            this.chart.ctx.save();
        }

        const dailyGoal = chart.config._config.data.dailyGoal;

        if (dailyGoal && xScale && yScale) {
            const xPos = xScale.getPixelForValue(dailyGoal);

            this.chart.ctx.beginPath();
            this.chart.ctx.moveTo(xPos, Math.round(yScale.top));
            this.chart.ctx.strokeStyle = goalColor; // @NOTE: --color-green here, do pass in and don't hard code here
            this.chart.ctx.setLineDash([5, 5]);
            this.chart.ctx.lineWidth = 1;
            this.chart.ctx.lineTo(xPos, Math.round(yScale.bottom));
            this.chart.ctx.stroke();

            this.chart.ctx.font = "bold 8px 'Grotesk', 'arial'";
            this.chart.ctx.textAlign  = "center";
            this.chart.ctx.fillStyle = goalColor;
            this.chart.ctx.fillText("GOAL", xPos, yScale.top - 10);

            this.chart.ctx.save();
        }

        super.draw(arguments);
    }
}
CustomBarHorizontalController.id = 'CustomBarHorizontal';
CustomBarHorizontalController.defaults = BarController.defaults;

export default CustomBarHorizontalController;